const CHECK_CLARITY_AVAILABILITY_TIMEOUT = 100

export default defineNuxtPlugin({
  name: 'app/clarity',
  setup() {
    const features = useFeatures()
    const variantFeatures = computed(() =>
      features.value
        .filter((feature) => feature.variant)
        .map((feature) => [feature.name, feature.variant!.name]),
    )

    const initializeClarity = () => {
      if (typeof window.clarity === 'undefined') return

      watchImmediate(variantFeatures, (entries) => {
        entries.forEach(([name, value]) => {
          window.clarity('set', name, value)
        })
      })
    }

    const checkClarity = () => {
      if (typeof window.clarity !== 'undefined') {
        initializeClarity()
      } else {
        setTimeout(checkClarity, CHECK_CLARITY_AVAILABILITY_TIMEOUT)
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkClarity)
    } else {
      checkClarity()
    }
  },
})

declare global {
  interface Window {
    clarity: any
  }
}
